import React from 'react'
import moment from 'moment'
import IconSVG from 'svg-inline-react'
import closeSrc from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/navigation/close.svg'

import style from './style.styl'

const toHex = colorCode => `#${colorCode}`

const MessengerBuilder = ({ themeColors, avatarUrl, name }) => (
  <div className={style.MessengerBuilder}>
    <div className="message-header" style={{backgroundColor: toHex(themeColors.backgroundColor)}}>
      <div className="header-avatar">
        <div className="avatar" style={{ backgroundImage: `url(${avatarUrl})` }} />
        <div className="avatar-name" style={{color: toHex(themeColors.foregroundColor)}}>{name}</div>
      </div>
      <div className="close-button" style={{ fill: toHex(themeColors.foregroundColor)}}>
        <IconSVG src={closeSrc}/>
      </div>
    </div>
    <div className="messages-container" style={{ backgroundColor: themeColors.widgetBackgroundColor }}>
      <div className="message is-end-user">
        <div className="message-container">
          <div
            className="message-item"
            style={{
              backgroundColor: toHex(themeColors.backgroundColor),
              color: toHex(themeColors.textColor),
            }}
          >
            Hey there! I have some questions.
          </div>
        </div>
      </div>
      <div className="message">
        <div className="avatar">
          <div className="avatar-image" style={{ backgroundImage: `url(${avatarUrl})` }} />
        </div>
        <div className="message-chain">
          <div className="message-container">
            <div className="info-line flex">{name}</div>
            <div
              className="message-item"
              style={{
                backgroundColor: toHex('f4f4f4'),
                color: '#222222',
                maxWidth: '228px'
              }}
            >
              Hey there! We’re excited to help you out. Let us know your email address so that we can follow up in case we get disconnected.
            </div>
          </div>
          <div className="message-container">
            <div
              className="message-item email-item"
            >
              <div className="email-title">Email Address</div>
              <div className="email-input">
                <div
                  className="email-submit"
                  style={{
                    backgroundColor: toHex(themeColors.backgroundColor)
                  }}
                >
                  <div style={{color: toHex(themeColors.foregroundColor)}}>SUBMIT</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="message is-end-user">
        <div className="message-container">
          <div
            className="message-item bot-button"
            style={{
              backgroundColor: toHex(themeColors.foregroundColor),
              color: toHex(themeColors.backgroundColor),
              borderColor: toHex(themeColors.backgroundColor),
            }}
            onMouseEnter={(event) => {
              event.target.style.backgroundColor = toHex(themeColors.backgroundColor)
              event.target.style.color = toHex(themeColors.foregroundColor)
            }}
            onMouseLeave={(event) => {
              event.target.style.backgroundColor = toHex(themeColors.foregroundColor)
              event.target.style.color = toHex(themeColors.backgroundColor)
            }}
          >
            I want to do something else
          </div>
          <div
            className="message-item bot-button"
            style={{
              backgroundColor: toHex(themeColors.foregroundColor),
              color: toHex(themeColors.backgroundColor),
              borderColor: toHex(themeColors.backgroundColor),
            }}
            onMouseEnter={(event) => {
              event.target.style.backgroundColor = toHex(themeColors.backgroundColor)
              event.target.style.color = toHex(themeColors.foregroundColor)
            }}
            onMouseLeave={(event) => {
              event.target.style.backgroundColor = toHex(themeColors.foregroundColor)
              event.target.style.color = toHex(themeColors.backgroundColor)
            }}
          >
            Support
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default MessengerBuilder



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/MessengerBuilder/index.js